import DataDisplayRowI from "../DataDisplayRowI";
import getMainRow from "../DataDisplayRow/MainRow";
import DataDisplayTable from "../DataDisplayTable";

class MainTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getMainRow()
    }
}

let mainTable: MainTable | null = null;

export default function getMainTable(): MainTable {
    if (mainTable === null)
        mainTable = new MainTable()
    return mainTable
}